export const ELOQUA_COOKIE = 'ELOQUA'
export const MARKETO_COOKIE = '_mkto_trk'
export const PARDOT_COOKIE = 'visitor_id'
export const DRIFT_ANONYMOUS_ID_COOKIE_V1 = 'driftt_aid'
export const DRIFT_ANONYMOUS_ID_COOKIE = 'drift_aid'
export const DRIFT_EXTERNAL_ID_COOKIE = 'drift_eid'
export const DRIFT_EXTERNAL_ID_COOKIE_V1 = 'driftt_eid'
export const DRIFT_USER_JWT_COOKIE = 'drift_ujwt'
export const DRIFT_CAMPAIGN_REFRESH_TOKEN = 'drift_campaign_refresh'
export const DRIFT_STAGED_FORM_DATA = 'drift_staged_form_data'

export const INTEGRATION_COOKIES = [
  ELOQUA_COOKIE,
  MARKETO_COOKIE
]

export const DRIFT_COOKIES = [
  DRIFT_USER_JWT_COOKIE,
  DRIFT_ANONYMOUS_ID_COOKIE,
  DRIFT_ANONYMOUS_ID_COOKIE_V1,
  DRIFT_EXTERNAL_ID_COOKIE,
  DRIFT_EXTERNAL_ID_COOKIE_V1,
  DRIFT_CAMPAIGN_REFRESH_TOKEN
]
